import { nativeEnum } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Earning_Mechanism_Product_Counting_Attribute } from '@occc/graphql';

export const CountProductsBySchema = nativeEnum(Earning_Mechanism_Product_Counting_Attribute, {
  required_error: IS_REQUIRED,
});
